export default __webpack_public_path__ + "static/frame-003-82b3b0da727523b2507cd28df33224e5.png";